<template>
  <transition name="modal" appear>
    <div class="modal-mask" style="color: #000; z-index: 2500;" v-loading="loading">
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="row justify-content-center">
          <div class="col-md-5 col-12" @click.stop="">
            <div class="card shadow" style="max-height: 500px;overflow-y: scroll;overflow-x:hidden">
              <div class="card-head">
                <div class="row px-3 pt-3">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <h2 class="my-2">RFID History</h2>
                    <span class="has-interaction" @click="$emit('close')">
                      <i class="fa-lg fas fa-times"></i>
                    </span>
                  </div>
                  <div class="col-12">
                    <hr />
                  </div>
                </div>
              </div>
              <div class="card-body pt-0" style="padding-right: 50px;">
                <p><strong>Log history for RFID {{ rfid }}</strong></p>
                <el-timeline>
                  <el-timeline-item v-for="(activity, index) in activities" :key="index" :icon="activity.icon"
                    :type="activity.type" :color="'#0bbd87'" :size="activity.size" :hollow="activity.hollow"
                    :timestamp="moment(activity.timestamp).format('DD/MM/YYYY')" placement="top">
                    <template #dot>
                      <div class="bg-cello" style="
                          width: 25px;
                          height: 25px;
                          border-radius: 12px;
                          text-align: center;
                          font-size: 17px;
                          left: -9px;
                          position: absolute;
                          top: -1px;
                        ">
                        <i class="far fa-arrow-right text-white" aria-hidden="true"></i>
                      </div>
                    </template>
                    <el-card>
                      <p class="mb-0">
                        <strong>{{
                          activity.date_label && activity.event_date ? activity.date_label : 'Date'
                        }}:</strong>
                        {{
                          activity.event_date ? moment(activity.event_date).format('DD/MM/YYYY') :
                          moment(activity.timestamp).format('DD/MM/YYYY')
                        }}
                      </p>
                      <p class="mb-0">
                        <strong>Event:</strong>
                        <span class="text-danger" v-if="activity.event == 'deleted'">Deleted</span>
                        <span class="text-warning" v-else-if="activity.event == 'deceased'">Deceased</span>
                        <span class="text-success" v-else-if="activity.event == 'closed out'">Closed Out</span>
                        <span class="text-info" v-else-if="activity.event == 'created'">Created</span>
                      </p>
                      <p class="mb-0"><strong>Message:</strong>
                        {{ activity.content }}
                      </p>
                      <p class="mb-0" v-if="activity.business"><strong>Producer:</strong>
                        {{ activity.business }}
                      </p>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    rfid: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      activities: [],
      loading: false
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios.get(`/api/v2/portal/rfid-lookup/${this.rfid}`)
        .then(res => {
          this.activities = res.data
          this.loading = false;
        })
        .finally(_ => {
          this.loading = false;
        });
    }
  }
}
</script>